import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mentor-session',
  templateUrl: './mentor-session.component.html',
  styleUrls: ['./mentor-session.component.scss']
})
export class MentorSessionComponent implements OnInit {

 district_list: any[] = this.ApiService.all_districts;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  zones: any = this.ApiService.all_districts_zone;
  user_name: any = this.ApiService.user_details.firstname;
  user_id: any = this.ApiService.user_details.id;
  activity_type: any;
  activity_date: any;
  activity_time: any;
  activity: any;
  description: any;
  status: any;
  others: any;
  customers: any = [];
  summary_activity: any = [];
    MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  
  
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  editmeetingform !:FormGroup;
  CM_id: any;
  CM_zone: any;


  getChangeAssignedTo(assigned_to: any) {
    console.log(assigned_to)
    if (assigned_to === 'District') {
      $('#Check1').css('display','flex')
    } else {
       $('#Check1').css('display','none')
    }
      if (assigned_to === 'Zone') {
      $('#zones').css('display','block')
    } else {
       $('#zones').css('display','none')
    }
  }


  getChangeToConstituey(value: any) {
    console.log(value);
    this.user_constituency = this.ApiService.all_constituency[value];
      this.ApiService.datablelogin(value).subscribe((data: any) => {
      let obj = data;
        this.customers = obj.data;
  
      //console.log(obj.data.length);
    });
  }

  handleActivityTypeChange(value: any) {
    console.log(value);
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
        $('#others').css('display', 'none');
    }
  }

  handleAdding() {
    console.log('coming');
    let len = $('.adding').length ;
    let script = '<div class="adding adding_' + len + '"><br/><div class="row"><button class="btn btn-danger btn-sm"  >Cancel</button></div><div class="row"><div class="col-sm-6"><label class="form-label">User Name<span style="color:red">*</span></label>';
    script += '<input type="text" class="form-control" formControlName="add[user_name][]" placeholder="Enter User Name" required /></div><div class="col-sm-6"><label class="form-label">OB Status<span style="color:red">*</span></label>';
    script += '<select class="form-control" formControlName="add[ob_status][]"><option>Open</option><option>Inprogress</option><option>Completed</option></select></div></div><div class="row"><div class="col-md-12"><label class="form-label">OB Comments</label><textarea formControlName="add[comments][]" class="form-control"></textarea></div></div>';
    script += '<div class="row"><div class="col-md-12"><label class="form-label">OB Pictures<span style="color:red">*</span></label><input type="file" class="form-control" formControlName="add[ob_picture][]" /></div></div></div>';
    $('#adding').append(script);
  }


  handleDeleteClick(id: any) {
    
    $(`#adding_${id}`).remove();
  }

   onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }

  

  constructor(private fb: FormBuilder, private ApiService: ApiServiceService, private router: Router,
    private spinnerService: NgxSpinnerService, public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
    this.createmeetingform= this.fb.group({
 
      topics:['',Validators.required,],
      start_date:[this.getNextDay(),Validators.required],
      end_date:[this.getNextDay(),Validators.required],
      start_time:[this.current_time,Validators.required],
      end_time:[this.current_time,Validators.required],
      mode: ['', Validators.required],
      status: ['', Validators.required],
      user_id: [''],

    },{ validators: this.dateValidator })
    this.editformInitialize('false');

  }

  getNextDay(): string {
    const today = new Date();
    // Get tomorrow's date
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    // Format the date as "yyyy-MM-dd"
    return tomorrow.toISOString().split('T')[0];
  }
  dateValidator(group: FormGroup) {
    const startDate = group.get('start_date').value;
    const endDate = group.get('end_date').value;
    if (startDate && endDate && new Date(startDate) >= new Date(endDate)) {
      return { min: true };
    }
    return null;
  }
  getFutureDate(): string {
    // Get the selected Course Start Date value
    const startDateValue = this.createmeetingform.get('start_date').value;
    
    // Parse the selected Course Start Date value
    const startDate = new Date(startDateValue);
  
    // Increment the selected Course Start Date by one day
    startDate.setDate(startDate.getDate()+1);
    
    // Format the date as 'YYYY-MM-DD', which is the format accepted by <input type="date">
    return startDate.toISOString().split('T')[0];
  }

  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit(): void{
    this.handleBackButtonForModal();

    console.log(this.users,this.users.firstname, "sndknsdkjn");
    this.date=new Date();
    //document.write(today);
    this.customers=[];
    this.showSpinner();
    this.ApiService.getSessionVolunteer().subscribe((data: any) => {
      console.log(data,"s,mfdnsd");
     
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      ;})

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers'
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('start_date').setValue(this.getNextDay());
    this.createmeetingform.get('end_date').setValue(this.getNextDay());
    this.createmeetingform.get('start_time').setValue(this.current_time);
    this.createmeetingform.get('end_time').setValue(this.current_time);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  
  getdata(){
    this.customers=[];
        for(const prop in this.ApiService.tabledatameeting) {
            this.customers.push(this.ApiService.tabledatameeting[prop])
          }
          this.customers.pop();
    //console.log(this.ApiService.tabledataDA)
    //this.ApiService.viewtableOB();
    

  }


  handleClickNavigate(id: any) {
    this.router.navigate(['activity-summary', id]);
  }

  

  postdata(angForm1 : any) //angForm1
  {
    console.log(angForm1, "dsnkjkdsjnd");
        console.log(this.createmeetingform.status,
          angForm1,
          angForm1.value.meeting_name,
          angForm1.value.meeting_date,
        );
  
  
          this.spinner=true;

    this.ApiService.createSessionVolunteer(angForm1.value).subscribe((d:any) => {
      console.log(d,"sdndsbjbdsskbskj"); 
              this.spinnerService.hide();
      setTimeout(function () {
                       Swal.fire({
  title: "Your Session Volunteer created Successfully!",
   icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: '#015792',
                  iconColor: "#015792" ,

}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
    window.location.reload();
  } 
});
                
                },100)
            },

            error => {
                console.log(error);
            });
            
         
    }
   
    delete_CM(id: any) {
        console.log(id);
        Swal.fire({
            title: 'Are you sure want to delete this Session Volunteer?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            iconColor: '#015792',
            confirmButtonColor: '#015792',
            cancelButtonColor: '#e5183b'
        }).then((result) => {
            if (result.isConfirmed) {
                console.log('Implement delete functionality here');
                this.ApiService.deleteSessionVolunteer(id)
                    .pipe()
                    .subscribe(
                        data => {
                            Swal.fire({
                                title: 'Your Session Volunteer deleted Successfully!',
                                icon: 'success',
                                confirmButtonText: 'Okay',
                                confirmButtonColor: '#e5183b',
                                iconColor: '#e5183b'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.reload();
                                }
                            });
                        },
                        error => {
                            console.log(error);
                        }
                    );
            }
        });
    }
    

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
//dropdown overlay reduced for mobileview
    const popupelement = this.elementRef.nativeElement.querySelector('.modal-content');
    if (popupelement) {
      const targetElement = popupelement.querySelector('.dropdown-list');
      if (targetElement) {
        this.renderer.setStyle(targetElement, 'overflow-y', 'hidden');
      }
    }
  }
  CM_name:any;
  CM_meeting_location:any;
  CM_date:any;
  CM_time: any;
  CM_description: any;
  CM_activity_type:any;
  CM_comments:any;
  CM_participants:any;
  CM_constituency: any;
  CM_assigned_to: any;
  CM_status: any;
  CM_activity: any;
  CM_others: any;
  CM_district: any;
  CM_zone_districts: any;
  CM_topics: any;
  CM_start_date: any;
  CM_end_date: any;
  CM_start_time: any;
  CM_end_time: any;
  CM_mode: any;
  
  

editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton,"dsbskdb");
    //console.log(a.date)
    if (editbutton == 'edit') {
      $('#card_title').html('SESSION VOLUNTEER EDIT');
      this.editfield = true;
    } else {
      $('#card_title').html('SESSION VOLUNTEER SHOW');
      this.editfield = false;
      

    }
    this.CM_id = a.id;
      
      this.CM_topics = a.topics;
      this.CM_start_date=a.start_date;
      this.CM_end_date=a.end_date;
      this.CM_start_time = a.start_tiime;
    this.CM_end_time = a.end_time;
    this.CM_mode = a.mode;

      this.CM_status=a.status;

    
   
    
          
          this.editformInitialize(false);
    
    this.editmeetingform.get('topics').setValue(a.topics);
    this.editmeetingform.get('start_date').setValue(a.start_date);
    this.editmeetingform.get('end_date').setValue(a.end_date);
    this.editmeetingform.get('start_time').setValue(a.start_tiime);
    this.editmeetingform.get('end_time').setValue(a.end_time);
    this.editmeetingform.get('status').setValue(a.status);
    this.editmeetingform.get('mode').setValue(a.mode);
 

    }
          
     
       
          
          
  editformInitialize(a){
    this.editmeetingform= this.fb.group({
     topics:['',Validators.required,],
      start_date:[this.current_date,Validators.required],
      end_date:[this.current_date,Validators.required],
      start_time:[this.current_time,Validators.required],
      end_time:[this.current_time,[Validators.required, this.endTimeAfterStartTimeValidator]],
      mode: ['', Validators.required],
      status: ['', Validators.required],
      user_id: [''],
      
  });
  }
  endTimeAfterStartTimeValidator(control: { value: string; parent: { get: (arg0: string) => { value: string; }; }; }): { [key: string]: boolean } | null {
    const startTime = control.parent?.get('start_time')?.value;
    const endTime = control.value;

    if (startTime && endTime && startTime > endTime) {
      return { 'endTimeBeforeStartTime': true };
    }

    return null;
  }
  updatedata(updateform,id){

    // this.spinner = true;
    this.ApiService.updateSessionVolunteer(this.CM_id,updateform.value).pipe().subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
        setTimeout(function () {
          Swal.fire({
            title: "Your Session Volunteer updated Successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: '#015792',
            iconColor: "#015792" 
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        }, 100);
        
        },
      
      error => {
        console.log(error);
      });
  }
//reset form values in createform
  Formreset(){
      this.createmeetingform.reset();
      this.hidden=true;
      this.MeetingOptions='';
      this.participantsptions='';
  }
  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }
  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }
  
}
